
// @ts-nocheck


export const localeCodes =  [
  "en-US",
  "it-IT",
  "fr-FR"
]

export const localeLoaders = {
  "en-US": [{ key: "../locales/en.json", load: () => import("../locales/en.json" /* webpackChunkName: "locale__home_les_dev_blob_locales_en_json" */), cache: true }],
  "it-IT": [{ key: "../locales/it.json", load: () => import("../locales/it.json" /* webpackChunkName: "locale__home_les_dev_blob_locales_it_json" */), cache: true }],
  "fr-FR": [{ key: "../locales/fr.json", load: () => import("../locales/fr.json" /* webpackChunkName: "locale__home_les_dev_blob_locales_fr_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en-US",
      "language": "en-EN",
      "name": "English",
      "files": [
        "/home/les/dev/blob/locales/en.json"
      ]
    },
    {
      "code": "it-IT",
      "language": "it-IT",
      "name": "Italiano",
      "files": [
        "/home/les/dev/blob/locales/it.json"
      ]
    },
    {
      "code": "fr-FR",
      "language": "fr-FR",
      "name": "Francais",
      "files": [
        "/home/les/dev/blob/locales/fr.json"
      ]
    }
  ],
  "defaultLocale": "en-US",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "./locales/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "runtimeOnly": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en-US",
    "language": "en-EN",
    "name": "English",
    "files": [
      {
        "path": "/home/les/dev/blob/locales/en.json"
      }
    ]
  },
  {
    "code": "it-IT",
    "language": "it-IT",
    "name": "Italiano",
    "files": [
      {
        "path": "/home/les/dev/blob/locales/it.json"
      }
    ]
  },
  {
    "code": "fr-FR",
    "language": "fr-FR",
    "name": "Francais",
    "files": [
      {
        "path": "/home/les/dev/blob/locales/fr.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
